(function () {
  var ORTE = { de: "de-DE", en: "en-GB", en_us: "en-US" };
  var NOT = {
    de: { fehler_technik: "Die Sendungsdaten sind gerade nicht erreichbar. Bitte versuch es gleich noch einmal.",
          fehler_nicht_gefunden: "Bestellung nicht gefunden. Bitte prüfe deine Eingabe oder wende dich an unseren Kundensupport." },
    en: { fehler_technik: "Tracking details aren't available right now. Please try again shortly.",
          fehler_nicht_gefunden: "Order not found. Please check your details or contact our support team." }
  };
  var HAKEN = '<svg viewBox="0 0 12 12" fill="none" aria-hidden="true"><path d="M2.5 6.2l2.3 2.3 4.7-5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var TRUCK_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 30" width="52" height="30">' +
    '<rect x="1" y="2" width="28" height="19" rx="1.5" fill="#9AA3AD" stroke="#6B7280" stroke-width="0.6"/>' +
    '<path d="M29 9L29 21L45 21L45 14L39 9Z" fill="#9AA3AD" stroke="#6B7280" stroke-width="0.6"/>' +
    '<path d="M30.5 10.5L37.5 10.5L43.5 14.5L43.5 16.5L30.5 16.5Z" fill="#D7E3EC" opacity="0.9"/>' +
    '<rect x="5" y="6" width="20" height="3" rx="1.5" fill="#C3CAD2" opacity="0.8"/>' +
    '<rect x="5" y="11" width="20" height="3" rx="1.5" fill="#C3CAD2" opacity="0.6"/>' +
    '<circle cx="10" cy="24" r="3.5" fill="#444" stroke="#333" stroke-width="0.7"/>' +
    '<circle cx="10" cy="24" r="1.5" fill="#aaa"/>' +
    '<circle cx="38" cy="24" r="3.5" fill="#444" stroke="#333" stroke-width="0.7"/>' +
    '<circle cx="38" cy="24" r="1.5" fill="#aaa"/>' +
    '<rect x="45" y="12" width="2.5" height="2.5" rx="0.5" fill="#888" opacity="0.5"/></svg>';

  var LAGER_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">' +
    '<path d="M3 21V9l9-6 9 6v12H3z" fill="#16A34A" stroke="#15803D" stroke-width="1"/>' +
    '<rect x="8" y="14" width="8" height="7" rx="1" fill="#BBF7D0"/>' +
    '<path d="M3 9l9-6 9 6" fill="none" stroke="#15803D" stroke-width="1.5"/></svg>';

  var HAUS_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36 36" width="36" height="36">' +
    '<circle cx="18" cy="18" r="16" fill="#DC2626" stroke="#fff" stroke-width="2"/>' +
    '<path d="M18 10l-8 7h3v7h10v-7h3z" fill="#fff"/></svg>';

  var HAUS_GRUEN_SVG = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 44 44" width="44" height="44">' +
    '<circle cx="22" cy="22" r="20" fill="#16A34A" stroke="#fff" stroke-width="2"/>' +
    '<path d="M22 12l-9 8h3v8h12v-8h3z" fill="#fff"/>' +
    '<circle cx="34" cy="10" r="8" fill="#fff"/>' +
    '<path d="M30 10l2.5 2.5 5-5" fill="none" stroke="#16A34A" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  var CHAT_SOUND_URL = "data:audio/wav;base64,UklGRiQAAABXQVZFZm10IBAAAAABAAEARKwAAIhYAQACABAAZGF0YQAAAAA=";

  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  function fuellen(t, w) {
    return String(t || "").replace(/\{([a-z_]+)\}/g, function (m, k) { return w[k] != null ? w[k] : m; });
  }

  function mailLink(text, mail) {
    if (!mail) return esc(text);
    var teile = String(text).split(mail);
    return teile.map(esc).join('<a href="mailto:' + esc(mail) + '">' + esc(mail) + "</a>");
  }

  function zeitText(iso, sprache) {
    var d = new Date(iso);
    if (isNaN(d)) return { tag: iso, uhr: "" };
    var ort = ORTE[sprache] || String(sprache || "de").replace("_", "-");
    try {
      return {
        tag: new Intl.DateTimeFormat(ort, { day: "numeric", month: "short" }).format(d),
        uhr: new Intl.DateTimeFormat(ort, { hour: "2-digit", minute: "2-digit" }).format(d)
      };
    } catch (e) {
      return { tag: iso.slice(0, 10), uhr: iso.slice(11, 16) };
    }
  }

  // ---------- Karte ----------

  function karteErstellen(container, daten) {
    if (!daten || !daten.route || !window.L) return;

    var map = L.map(container, {
      zoomControl: true,
      scrollWheelZoom: true,
      dragging: true,
      attributionControl: false,
    });

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 18,
    }).addTo(map);

    L.control.attribution({ prefix: false, position: "bottomright" })
      .addAttribution('&copy; <a href="https://www.openstreetmap.org/copyright">OSM</a>')
      .addTo(map);

    var lagerIcon = L.divIcon({
      html: LAGER_SVG, className: "pkst-marker-lager", iconSize: [24, 24], iconAnchor: [12, 12]
    });
    L.marker([daten.start[0], daten.start[1]], { icon: lagerIcon }).addTo(map);

    var istZugestellt = daten.zugestellt;
    var hausSvg = istZugestellt ? HAUS_GRUEN_SVG : HAUS_SVG;
    var hausGroesse = istZugestellt ? [44, 44] : [36, 36];
    var hausAnker = istZugestellt ? [22, 22] : [18, 18];
    var hausIcon = L.divIcon({
      html: hausSvg, className: "pkst-marker-haus", iconSize: hausGroesse, iconAnchor: hausAnker
    });
    var hausMarker = L.marker([daten.ziel[0], daten.ziel[1]], { icon: hausIcon }).addTo(map);
    if (daten.ziel_adresse) {
      hausMarker.bindTooltip(daten.ziel_adresse, { direction: "top", offset: [0, -20] });
    }

    if (daten.truck && daten.phase >= 4 && !istZugestellt) {
      var truckHtml = '<div class="pkst-puls-ring"></div>' + TRUCK_SVG;
      var truckIcon = L.divIcon({
        html: truckHtml, className: "pkst-marker-truck", iconSize: [52, 30], iconAnchor: [26, 15]
      });
      L.marker([daten.truck[0], daten.truck[1]], { icon: truckIcon, zIndexOffset: 1000 }).addTo(map);
    }

    var punkte = [[daten.start[0], daten.start[1]], [daten.ziel[0], daten.ziel[1]]];
    if (daten.truck) punkte.push([daten.truck[0], daten.truck[1]]);
    var bounds = L.latLngBounds(punkte);
    map.fitBounds(bounds, { padding: [40, 40], maxZoom: 10 });

    return map;
  }

  // ---------- Ergebnis rendern ----------

  function paketHtml(p, daten, ui) {
    var h = "";
    h += '<div class="pkst-status" aria-live="polite">';
    h += '<h2 class="pkst-status-titel">' + esc(p.titel) + "</h2>";
    if (p.text) h += '<p class="pkst-status-text">' + mailLink(p.text, daten.support) + "</p>";
    h += "</div>";


    (p.notizen || []).forEach(function (n) {
      h += '<div class="pkst-nachricht"><strong>' + esc(fuellen(ui.nachricht_von, { marke: daten.marke })) + "</strong>";
      h += "<span>" + esc(n.datum || "") + "</span><p>" + esc(n.text) + "</p></div>";
    });

    h += '<div class="pkst-abschnitt"><h3>' + esc(ui.verlauf) + "</h3>";
    if (p.zusteller && p.zusteller.nummer) {
      h += '<div class="pkst-zusteller"><div><span>' + esc(fuellen(ui.zustellnummer, { zusteller: p.zusteller.name })) + "</span><b>" + esc(p.zusteller.nummer) + "</b></div>";
      if (p.zusteller.link) h += '<a href="' + esc(p.zusteller.link) + '" target="_blank" rel="noopener">' + esc(fuellen(ui.beim_zusteller_ansehen, { zusteller: p.zusteller.name })) + "</a>";
      h += "</div>";
    }
    if (!p.verlauf || !p.verlauf.length) {
      h += '<p class="pkst-leer" style="margin-top:14px">' + esc(ui.keine_eintraege) + "</p>";
    } else {
      h += '<ol class="pkst-verlauf" style="margin-top:18px">';
      p.verlauf.forEach(function (e, i) {
        var z = zeitText(e.zeit, daten.sprache);
        h += '<li class="pkst-eintrag"' + (i >= 5 ? " hidden data-mehr" : "") + '><div class="pkst-eintrag-zeit">' + esc(z.tag) + "<br>" + esc(z.uhr) + "</div>";
        h += '<div class="pkst-eintrag-inhalt">' + esc(e.text) + (e.ort ? '<span class="pkst-eintrag-ort">' + esc(e.ort) + "</span>" : "") + "</div></li>";
      });
      h += "</ol>";
      if (p.verlauf.length > 5) h += '<button type="button" class="pkst-mehr" data-umschalten aria-expanded="false">' + esc(ui.alle_eintraege) + "</button>";
    }
    h += "</div>";

    if (p.vorschau && p.vorschau.length) {
      h += '<div class="pkst-abschnitt pkst-vorschau"><h3>' + esc(p.vorschau_titel) + "</h3>";
      h += '<p class="pkst-vorschau-hinweis">' + esc(p.vorschau_hinweis) + "</p>";
      h += '<ol class="pkst-vorschau-liste">';
      p.vorschau.forEach(function (v) {
        h += '<li><span class="pkst-vorschau-name">' + esc(v.name) + "</span>" + (v.zeitraum ? '<span class="pkst-vorschau-zeit">' + esc(v.zeitraum) + "</span>" : "") + "</li>";
      });
      h += "</ol></div>";
    }
    return h;
  }

  function ergebnisHtml(daten) {
    var ui = daten.ui;
    var h = '<div class="pkst-ergebnis">';

    var nrText = daten.bestellung.nummer ? esc(ui.bestellung + " " + daten.bestellung.nummer) : esc(daten.marke);
    var kundenname = daten.bestellung.kundenname || "";
    h += '<div class="pkst-bestellung"><h2>' + nrText;
    if (kundenname) h += ' <span class="pkst-kundenname">&mdash; ' + esc(kundenname) + '</span>';
    h += "</h2></div>";

    if (daten.banner) h += '<p class="pkst-banner">' + esc(daten.banner) + "</p>";

    if (daten.karte) {
      h += '<div class="pkst-karte-wrap"><div class="pkst-karte-spinner"><span></span><span></span><span></span></div><div class="pkst-karte" id="pkst-map"></div></div>';
    }

    daten.pakete.forEach(function (p, i) {
      h += '<div class="pkst-paket">' + paketHtml(p, daten, ui) + "</div>";
    });

    if (daten.artikel && daten.artikel.length) {
      h += '<div class="pkst-abschnitt"><h3>' + esc(ui.inhalt) + '</h3><ul class="pkst-artikel">';
      daten.artikel.forEach(function (a) {
        h += "<li>" + (a.bild ? '<img src="' + esc(a.bild) + '" alt="" loading="lazy" width="56" height="56">' : '<span class="pkst-bild-leer"></span>');
        h += '<span class="pkst-artikel-name">' + esc(a.titel) + '</span><span class="pkst-artikel-menge">' + esc(ui.menge) + " " + esc(a.menge) + "</span></li>";
      });
      h += "</ul></div>";
    }

    if (daten.support) h += '<p class="pkst-hilfe">' + mailLink(fuellen(ui.hilfe, { support: daten.support }), daten.support) + "</p>";

    h += "</div>";
    return h;
  }

  function verdrahten(box, ui) {
    box.querySelectorAll("[data-umschalten]").forEach(function (knopf) {
      knopf.addEventListener("click", function () {
        var liste = knopf.previousElementSibling;
        var auf = knopf.getAttribute("aria-expanded") === "true";
        liste.querySelectorAll("[data-mehr]").forEach(function (li) { li.hidden = auf; });
        knopf.setAttribute("aria-expanded", String(!auf));
        knopf.textContent = auf ? ui.alle_eintraege : ui.weniger_eintraege;
      });
    });
  }

  window.PaketstatusZeigen = function (box, daten) {
    box.innerHTML = ergebnisHtml(daten);
    verdrahten(box, daten.ui);

    if (daten.karte) {
      var mapEl = box.querySelector("#pkst-map");
      var spinner = box.querySelector(".pkst-karte-spinner");
      if (mapEl) {
        setTimeout(function () {
          karteErstellen(mapEl, daten.karte);
          if (spinner) spinner.style.display = "none";
        }, 100);
      }
    }
  };

  // ---------- Chat Widget ----------

  var CHAT_TEXTE = {
    de: {
      titel: "Maria | Kundenservice",
      platzhalter: "Schreib deine Frage ...",
      senden: "Senden",
      schluss: "Danke für deine Nachricht. Schreib uns gerne an {support}.",
      begruessung: "Hallo! Ich bin Maria vom {marke}-Team. Wie kann ich dir helfen?",
      limit: "Ich kann gerade nicht antworten. Schreib uns gerne direkt an {support}.",
      offline: "Unser Chat ist gerade nicht verfügbar. Schreib uns an {support}."
    },
    en: {
      titel: "Maria | Customer Service",
      platzhalter: "Type your question ...",
      senden: "Send",
      schluss: "Thanks for your message. Feel free to email us at {support}.",
      begruessung: "Hello! I'm Maria from the {marke} team. How can I help you?",
      limit: "I can't respond right now. Please email us at {support}.",
      offline: "Our chat is currently unavailable. Please email us at {support}."
    }
  };

  function chatWidget(api, daten) {
    var basis = (daten.sprache || "de").slice(0, 2);
    var ct = CHAT_TEXTE[basis] || CHAT_TEXTE.en;
    var chatVerlauf = [];
    var kontext = null;
    if (daten.pakete && daten.pakete[0]) {
      var p = daten.pakete[0];
      kontext = {
        bestellung_id: "", bestellnummer: (daten.bestellung || {}).nummer || "",
        titel: p.titel || "", eta: p.eta ? p.eta.text : "", tage: "",
        tracking_url: location.href
      };
    }

    var wrap = document.createElement("div");
    wrap.className = "pkst-chat-wrap";
    wrap.innerHTML =
      '<button class="pkst-chat-knopf" type="button" aria-label="' + esc(ct.titel) + '">' +
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"><path d="M9.5 9a3 3 0 115 2.1c-.7.7-2 1.2-2 2.4"/><circle cx="12.5" cy="17" r=".01" fill="currentColor" stroke-width="3"/></svg></button>' +
      '<div class="pkst-chat-fenster" hidden>' +
      '<div class="pkst-chat-kopf"><div class="pkst-chat-kopf-info"><div class="pkst-chat-avatar">M</div><span>' + esc(ct.titel) + '</span></div>' +
      '<button type="button" class="pkst-chat-x" aria-label="Schließen">&times;</button></div>' +
      '<div class="pkst-chat-verlauf"></div>' +
      '<form class="pkst-chat-form"><input type="text" placeholder="' + esc(ct.platzhalter) + '" maxlength="500" autocomplete="off">' +
      '<button type="submit">' + esc(ct.senden) + '</button></form></div>';

    var knopf = wrap.querySelector(".pkst-chat-knopf");
    var fenster = wrap.querySelector(".pkst-chat-fenster");
    var xBtn = wrap.querySelector(".pkst-chat-x");
    var verlaufEl = wrap.querySelector(".pkst-chat-verlauf");
    var chatForm = wrap.querySelector(".pkst-chat-form");
    var eingabe = chatForm.querySelector("input");
    var sendenBtn = chatForm.querySelector("button");
    var offen = false;
    var anzahl = 0;
    var begrusstSchon = false;

    var sound = null;
    try { sound = new Audio(CHAT_SOUND_URL); sound.volume = 0.3; } catch (e) {}

    function toggle() {
      offen = !offen;
      fenster.hidden = !offen;
      if (offen) {
        eingabe.focus();
        if (!begrusstSchon) {
          begrusstSchon = true;
          var text = fuellen(ct.begruessung, { marke: daten.marke || "", support: daten.support || "" });
          setTimeout(function () { tippAnzeige(text); }, 400);
        }
      }
    }
    knopf.addEventListener("click", toggle);
    xBtn.addEventListener("click", toggle);

    function blase(text, klasse) {
      var d = document.createElement("div");
      d.className = "pkst-chat-blase " + klasse;
      d.textContent = text;
      verlaufEl.appendChild(d);
      verlaufEl.scrollTop = verlaufEl.scrollHeight;
    }

    function tippAnzeige(endText) {
      var d = document.createElement("div");
      d.className = "pkst-chat-blase pkst-chat-bot pkst-chat-tippen";
      d.innerHTML = '<span></span><span></span><span></span>';
      verlaufEl.appendChild(d);
      verlaufEl.scrollTop = verlaufEl.scrollHeight;

      setTimeout(function () {
        d.remove();
        blase(endText, "pkst-chat-bot");
        if (sound) try { sound.play(); } catch (e) {}
      }, 1200);
    }

    chatForm.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var text = eingabe.value.trim();
      if (!text || anzahl >= 10) return;
      anzahl++;
      blase(text, "pkst-chat-user");
      chatVerlauf.push({ rolle: "user", text: text });
      eingabe.value = "";
      sendenBtn.disabled = true;

      var tippEl = document.createElement("div");
      tippEl.className = "pkst-chat-blase pkst-chat-bot pkst-chat-tippen";
      tippEl.innerHTML = '<span></span><span></span><span></span>';
      verlaufEl.appendChild(tippEl);
      verlaufEl.scrollTop = verlaufEl.scrollHeight;

      fetch(api + "/api/chat", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nachricht: text, kontext: kontext, verlauf: chatVerlauf.slice(-6), sprache: daten.sprache || "de" })
      }).then(function (r) { return r.json(); }).then(function (d) {
        setTimeout(function () {
          tippEl.remove();
          if (d.limit) {
            blase(fuellen(ct.limit, { support: daten.support || "" }), "pkst-chat-bot");
          } else {
            var antwort = d.antwort || fuellen(ct.offline, { support: daten.support || "" });
            blase(antwort, "pkst-chat-bot");
            chatVerlauf.push({ rolle: "assistant", text: antwort });
          }
          if (sound) try { sound.play(); } catch (e) {}
        }, 3000);
      }).catch(function () {
        tippEl.remove();
        blase(fuellen(ct.offline, { support: daten.support || "" }), "pkst-chat-bot");
      }).then(function () { sendenBtn.disabled = false; eingabe.focus(); });
    });

    document.body.appendChild(wrap);
  }

  // ---------- Init ----------

  var _origZeigen = null;

  function init() {
    document.querySelectorAll("[data-paketstatus]").forEach(function (w) {
      if (!w.getAttribute("data-bereit")) {
        w.setAttribute("data-bereit", "1");
        start(w);
      }
    });
  }

  function start(wurzel) {
    var api = (wurzel.getAttribute("data-api") || "").replace(/\/$/, "");
    var seitenSprache = wurzel.getAttribute("data-sprache") || document.documentElement.lang || "de";
    var markt = wurzel.getAttribute("data-markt") || "";
    var kopf = wurzel.querySelector("[data-kopf]");
    var form = wurzel.querySelector("[data-form]");
    var ergebnis = wurzel.querySelector("[data-ergebnis]");
    var ui = null;
    var params = new URLSearchParams(location.search);

    function notText(k) {
      var s = seitenSprache.slice(0, 2) === "de" ? "de" : "en";
      return (ui && ui[k]) || NOT[s][k] || NOT.en[k];
    }

    function laden() {
      ergebnis.hidden = false;
      ergebnis.innerHTML = '<div class="pkst-laden" role="status"><span></span><span></span><span></span></div>';
    }

    function formZeigen(fehler, feld) {
      kopf.hidden = false;
      form.hidden = false;
      ergebnis.hidden = true;
      var meldung = form.querySelector("[data-meldung]");
      form.querySelectorAll("input").forEach(function (i) { i.removeAttribute("aria-invalid"); });
      if (fehler) {
        meldung.textContent = fehler;
        meldung.hidden = false;
        if (feld) {
          var el = form.querySelector('[name="' + feld + '"]');
          if (el) { el.setAttribute("aria-invalid", "true"); el.focus(); }
        }
      } else {
        meldung.hidden = true;
      }
    }

    function zeigen(daten) {
      kopf.hidden = true;
      form.hidden = true;
      ergebnis.hidden = false;
      window.PaketstatusZeigen(ergebnis, daten);

      if (!document.querySelector(".pkst-chat-wrap")) {
        chatWidget(api, daten);
      }

      var neu = document.createElement("button");
      neu.type = "button";
      neu.className = "pkst-knopf pkst-knopf-leise pkst-neu";
      neu.textContent = daten.ui.neue_suche;
      neu.addEventListener("click", function () {
        history.replaceState(null, "", location.pathname);
        form.reset();
        formZeigen();
        var cw = document.querySelector(".pkst-chat-wrap");
        if (cw) cw.remove();
        window.scrollTo({ top: wurzel.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" });
      });
      ergebnis.querySelector(".pkst-ergebnis").appendChild(neu);
      window.scrollTo({ top: wurzel.getBoundingClientRect().top + window.pageYOffset - 80, behavior: "smooth" });
    }

    function fehlerText(code) {
      if (code === "zu_viele") return notText("fehler_zu_viele");
      if (code === "nicht_gefunden") return notText("fehler_nicht_gefunden");
      if (code === "kontakt") return notText("fehler_kontakt");
      if (code === "leer") return notText("fehler_leer");
      return notText("fehler_technik");
    }

    function holen(url, optionen) {
      return fetch(url, optionen).then(function (r) {
        return r.json().catch(function () { return {}; }).then(function (d) {
          if (!r.ok || d.fehler) throw { code: d.fehler || "technik" };
          return d;
        });
      });
    }

    function abfrage(url, optionen, feld) {
      laden();
      holen(url, optionen).then(zeigen).catch(function (e) {
        formZeigen(fehlerText(e && e.code), e && e.code === "kontakt" ? "kontakt" : (e && e.code === "nicht_gefunden" ? feld : null));
      });
    }

    function formularBauen() {
      kopf.innerHTML = '<h1 class="pkst-titel">' + esc(ui.titel) + '</h1><p class="pkst-unter">' + esc(ui.unterzeile) + "</p>";
      form.innerHTML =
        '<div class="pkst-feld"><label for="pkst-nummer">' + esc(ui.feld_nummer) + '</label><input id="pkst-nummer" name="nummer" autocomplete="off" inputmode="text" placeholder="' + esc(ui.feld_nummer_platzhalter) + '" required></div>' +
        '<div class="pkst-feld"><label for="pkst-kontakt">' + esc(ui.feld_kontakt) + '</label><input id="pkst-kontakt" name="kontakt" autocomplete="email" inputmode="email"></div>' +
        '<p class="pkst-meldung" data-meldung role="alert" hidden></p>' +
        '<button class="pkst-knopf" type="submit">' + esc(ui.knopf) + "</button>";
      var vor = params.get("order") || params.get("bestellung");
      if (vor) form.querySelector('[name="nummer"]').value = vor.replace(/[^0-9A-Za-z#]/g, "");
    }

    form.addEventListener("submit", function (ev) {
      ev.preventDefault();
      var nummer = form.querySelector('[name="nummer"]').value.trim();
      var kontakt = form.querySelector('[name="kontakt"]').value.trim();
      if (!nummer) return formZeigen(notText("fehler_leer"), "nummer");
      var reine = nummer.replace(/^#/, "");
      if (/^\d{1,8}$/.test(reine) && !kontakt) return formZeigen(notText("fehler_kontakt"), "kontakt");
      var knopfEl = form.querySelector(".pkst-knopf");
      knopfEl.disabled = true;
      knopfEl.innerHTML = '<span class="pkst-kreis" aria-hidden="true"></span>' + esc(ui.laden);
      holen(api + "/api/suche", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ nummer: nummer, kontakt: kontakt, sprache: seitenSprache, markt: markt })
      }).then(function (d) {
        if (/^\d{1,8}$/.test(reine)) history.replaceState(null, "", location.pathname + "?order=" + encodeURIComponent(reine));
        zeigen(d);
      }).catch(function (e) {
        formZeigen(fehlerText(e && e.code), e && e.code === "kontakt" ? "kontakt" : "nummer");
      }).then(function () {
        knopfEl.disabled = false;
        knopfEl.textContent = ui.knopf;
      });
    });

    laden();
    kopf.hidden = true;
    form.hidden = true;
    holen(api + "/api/texte?sprache=" + encodeURIComponent(seitenSprache) + "&markt=" + encodeURIComponent(markt))
      .then(function (d) { ui = d.ui; })
      .catch(function () { ui = null; })
      .then(function () {
        if (!ui) {
          ergebnis.innerHTML = '<p class="pkst-meldung" role="alert">' + esc(notText("fehler_technik")) + "</p>";
          return;
        }
        formularBauen();
        var o = params.get("o"), k = params.get("k"), n = params.get("nums") || params.get("n");
        var q = "&sprache=" + encodeURIComponent(seitenSprache) + "&markt=" + encodeURIComponent(markt);
        if (o && k) return abfrage(api + "/api/link?o=" + encodeURIComponent(o) + "&k=" + encodeURIComponent(k) + q, {}, "nummer");
        if (n) return abfrage(api + "/api/sendung?n=" + encodeURIComponent(n.split(",")[0]) + q, {}, "nummer");
        formZeigen();
      });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();
